import React from 'react';
import { Badge } from 'reactstrap';
import { FaCheckCircle, FaExclamationTriangle, FaClock } from 'react-icons/fa';

const StatusBadge = ({ status }) => {
  let color, icon;
  
  switch(status) {
    case 'Approved':
    case 'Completed':
      color = 'success';
      icon = <FaCheckCircle />;
      break;
    case 'Rejected':
    case 'Failed':
      color = 'danger';
      icon = <FaExclamationTriangle />;
      break;
    case 'Pending':
    case 'In Progress':
      color = 'warning';
      icon = <FaClock />;
      break;
    default:
      color = 'secondary';
      icon = null;
  }
 
  return (
    <Badge 
      color={color} 
      pill 
      className="d-inline-flex align-items-center"
      style={{
        height: '24px',
        minWidth: '100px',
        fontSize: '0.75rem',
        fontWeight: 500,
        justifyContent: 'center',
        padding: '0 8px',
        lineHeight: '1.5',
        gap:"10px",
      }}
    >
     <span>{icon && React.cloneElement(icon, { className: 'mr-1', size: 10 })}</span>
      <span>{status}</span>
    </Badge>
  );
};

export default StatusBadge;